export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-web-b0514477e2a76ab0f9b99a4e4311a935.svg";